import React from 'react';
import { Link } from 'react-router-dom';
import './header.css';
import {IoLogoLinkedin} from  'react-icons/io';
import {IoLogoGithub} from  'react-icons/io';
import { IconContext } from "react-icons";
import { IoIosMail } from "react-icons/io";

export default () => {
  return (
    <header className="c-header">
      <nav className="c-header__nav">
        <div className="c-header__title">
          {/* <span role="img" aria-label="Today">
            🗓️
          </span>
          <span role="img" aria-label="I">
            😄
          </span>
          <span role="img" aria-label="learned">
            ✏️
          </span>{' '} */}
          <Link className="o-paddedLink" to="/">
            Priyanshu Madan
          </Link>
        </div>
        <div className="c-header__icon ">
        <IconContext.Provider value={{ color: "grey", size:"3em" }}>
                 <a href="https://www.linkedin.com/in/priyanshumadan/"><IoLogoLinkedin/></a>
                 </IconContext.Provider>
                 <IconContext.Provider value={{ color: "grey", size:"3em" }}>
                 <a href="https://github.com/priyanshu-madan"><IoLogoGithub/></a>
                 </IconContext.Provider>
                 <IconContext.Provider value={{ color: "grey", size:"3em" }}>
                 <a href="mailto:pmadan3@illinois.edu"><IoIosMail/></a>
                 </IconContext.Provider></div>
        <Link to={'/ideas/'} className="c-header__button o-btn">
          Ideas Diary
        </Link>
        
      </nav>
    </header>
  );
};



// WEBPACK FOOTER //
// ./src/components/header.js